var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"input-unit-box"},[_c('el-input',_vm._g(_vm._b({attrs:{"clearable":""}},'el-input',_vm.$attrs,false),_vm.$listeners)),_c('span',{staticClass:"unit"},[_vm._v(_vm._s(_vm.unitName)+" ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }